module.exports = ".vertical-offset-100 {\n  padding-top: 150px; }\n\n.capslockalert {\n  color: red; }\n\n.alertmsg {\n  border-color: #a94442; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.scss
// module id = ./src/app/login/login.component.scss
// module chunks = main